/**
 * @author caijianjia
 * @date 2020/3/15 3:09 下午
 */
import axios from 'axios'
import md5 from 'js-md5'
import { images } from '../assets/images'
import * as utils from './utils'
import * as cocosUtils from './cocosUtils'
import * as enums from './enums'
import {RouteUtil} from "./routeUtil"
const _ = require('lodash')

const GlobalPlugin = {}
GlobalPlugin.install = (Vue) => {
  Vue.prototype.$axios = axios
  Vue.prototype.$md5 = md5
  Vue.prototype.$images = images
  Vue.prototype.$_ = _
  Vue.prototype.$utils = utils
  Vue.prototype.$cocosUtils = cocosUtils
  Vue.prototype.$RouteUtil = RouteUtil
  Vue.prototype.$cocosCompiles = false
  Vue.prototype.$colorLog = ({color, ...params}) => {
    console.log('retro%c '+ JSON.stringify({...params}),`color:${color || 'green'};`,)
  }
  Vue.prototype.$enums = enums
}
export default GlobalPlugin
